import { render, staticRenderFns } from "./SaleListLoader.vue?vue&type=template&id=5605ca52&scoped=true&"
import script from "./SaleListLoader.vue?vue&type=script&lang=js&"
export * from "./SaleListLoader.vue?vue&type=script&lang=js&"
import style0 from "./SaleListLoader.vue?vue&type=style&index=0&id=5605ca52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5605ca52",
  null
  
)

export default component.exports